// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * AdminPainel - Estilo padrão dos outros painéis (Painel de Score)
 * Tema moderno e tecnológico Sonik
 */

/* ==================== Tema (escopo do painel) ==================== */
.admin-painel-v2 {
  --brand-900: #0a3ea2;
  --brand-700: #1060ff;
  --brand-500: #1e75ff;
  --brand-300: #a8c7ff;
  --brand-100: #dbeafe;
  --card: #ffffff;
  --bg: #f0f4f9;
  --bg-gradient: linear-gradient(135deg, #f0f4f9 0%, #e8f0f7 100%);
  --text: #1f2937;
  --muted: #6b7280;
  --ok: #16a34a;
  --bad: #ef4444;
  --ring: #60a5fa;
  --shadow-sm: 0 2px 4px rgba(17, 12, 12, 0.04);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.12);
  --shadow-xl: 0 20px 50px rgba(0, 0, 0, 0.15);

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  min-height: 100%;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background: var(--bg-gradient);
  background-attachment: fixed;
  color: var(--text);
  position: relative;
}

.admin-painel-v2 * {
  box-sizing: border-box;
}

/* Efeito de partículas no fundo */
.admin-painel-v2::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    radial-gradient(circle at 20% 50%, rgba(30, 117, 255, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(16, 96, 255, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 40% 20%, rgba(10, 62, 162, 0.02) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

/* ==================== Header (Hero) ==================== */
.admin-painel-v2 .hero {
  background: linear-gradient(135deg, #0a3ea2 0%, #1060ff 30%, #1e75ff 70%, #3b82f6 100%);
  background-size: 200% 200%;
  animation: adminGradientShift 8s ease infinite;
  color: #fff;
  padding: 32px 18px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(10, 62, 162, 0.2);
}

@keyframes adminGradientShift {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.admin-painel-v2 .hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.08) 0%, transparent 50%);
  pointer-events: none;
}

.admin-painel-v2 .hero__inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  position: relative;
  z-index: 1;
}

.admin-painel-v2 .brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  margin-right: auto;
  transition: transform 0.3s ease;
}

.admin-painel-v2 .brand:hover {
  transform: translateX(2px);
}

.admin-painel-v2 .hero .title {
  font-weight: 800;
  letter-spacing: 0.5px;
  font-size: 28px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  background: linear-gradient(180deg, #ffffff 0%, #e0e7ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.admin-painel-v2 .toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* ==================== Botões ==================== */
.admin-painel-v2 .btn {
  background: linear-gradient(135deg, #1060ff 0%, #1e75ff 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 12px 20px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 8px 20px rgba(16, 96, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-decoration: none;
}

.admin-painel-v2 .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(16, 96, 255, 0.4);
  background: linear-gradient(135deg, #1e75ff 0%, #3b82f6 100%);
}

.admin-painel-v2 .btn:active {
  transform: translateY(0);
}

.admin-painel-v2 .btn--ghost {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.admin-painel-v2 .btn--ghost:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.admin-painel-v2 .btn--secondary {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.admin-painel-v2 .btn--secondary:hover {
  background: #e2e8f0;
  color: #334155;
  transform: translateY(-1px);
}

/* ==================== Layout ==================== */
.admin-painel-v2 .wrap {
  max-width: 1200px;
  margin: 24px auto;
  padding: 0 16px;
  position: relative;
  z-index: 1;
}

/* ==================== Card ==================== */
.admin-painel-v2 .card {
  background: var(--card);
  border-radius: 20px;
  padding: 24px;
  box-shadow: var(--shadow-md);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
}

.admin-painel-v2 .card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--brand-500), var(--brand-700));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.admin-painel-v2 .card:hover::before {
  opacity: 1;
}

.admin-painel-v2 .card:hover {
  box-shadow: var(--shadow-xl);
  transform: translateY(-4px);
  border-color: rgba(30, 117, 255, 0.2);
}

.admin-painel-v2 .card h3 {
  margin: 0 0 16px 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-painel-v2 .card h3::before {
  content: "";
  width: 4px;
  height: 20px;
  background: linear-gradient(180deg, var(--brand-500), var(--brand-700));
  border-radius: 2px;
}

/* ==================== Busca ==================== */
.admin-painel-v2 .search-row {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr auto;
  align-items: start;
  margin-bottom: 16px;
}

@media (max-width: 520px) {
  .admin-painel-v2 .search-row {
    grid-template-columns: 1fr;
  }
}

.admin-painel-v2 .search-row input[type="text"] {
  padding: 14px 18px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  font-size: 16px;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.admin-painel-v2 .search-row input[type="text"]:hover {
  border-color: var(--brand-300);
  box-shadow: 0 4px 8px rgba(30, 117, 255, 0.1);
}

.admin-painel-v2 .search-row input[type="text"]:focus {
  border-color: var(--brand-500);
  box-shadow: 0 0 0 4px rgba(30, 117, 255, 0.15), 0 4px 12px rgba(30, 117, 255, 0.2);
}

/* ==================== Tabela (restr-table) ==================== */
.admin-painel-v2 .restr-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  table-layout: auto;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.admin-painel-v2 .restr-table thead th {
  text-align: left;
  font-weight: 700;
  font-size: 11px;
  color: #475569;
  padding: 14px 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.admin-painel-v2 .restr-table tbody td {
  padding: 14px 16px;
  font-size: 14px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
  word-wrap: break-word;
  max-width: 200px;
  transition: background 0.2s ease;
}

.admin-painel-v2 .restr-table tbody tr:hover td {
  background: #f8fafc;
}

.admin-painel-v2 .restr-table tbody tr:last-child td {
  border-bottom: none;
}

/* Chips de permissão */
.admin-painel-v2 .chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  background: linear-gradient(135deg, #eef2f7 0%, #e5e7eb 100%);
  color: #1f2937;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.admin-painel-v2 .chip--brand {
  background: linear-gradient(135deg, var(--brand-100) 0%, var(--brand-300) 100%);
  color: var(--brand-900);
}

/* Muted text */
.admin-painel-v2 .muted {
  color: var(--muted);
  font-size: 13px;
  font-weight: 500;
}

/* Section head */
.admin-painel-v2 .section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 8px 0 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f4f9;
}

.admin-painel-v2 .section-head h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
}

/* Overrides para MUI dentro do painel */
.admin-painel-v2 .MuiOutlinedInput-root {
  border-radius: 12px;
}

.admin-painel-v2 .MuiOutlinedInput-notchedOutline {
  border-color: #e5e7eb;
}

.admin-painel-v2 .Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--brand-500) !important;
  border-width: 2px !important;
}

.admin-painel-v2 .MuiSelect-select,
.admin-painel-v2 .MuiTableCell-root {
  font-size: 14px;
}

.admin-painel-v2 .admin-table-wrap {
  overflow-x: auto;
  width: 100%;
  margin-top: 16px;
}

.admin-painel-v2 .admin-table-wrap .restr-table {
  min-width: 800px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminPainel.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,sEAAsE;AACtE;EACE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,2CAA2C;EAC3C,4CAA4C;EAC5C,4CAA4C;;EAE5C,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,8FAA8F;EAC9F,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;mFAGiF;EACjF,oBAAoB;EACpB,UAAU;AACZ;;AAEA,4DAA4D;AAC5D;EACE,uFAAuF;EACvF,0BAA0B;EAC1B,8CAA8C;EAC9C,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW,2BAA2B,EAAE;EACxC,MAAM,6BAA6B,EAAE;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;qFAEmF;EACnF,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yCAAyC;EACzC,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,iDAAiD;EACjD,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sEAAsE;EACtE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,uEAAuE;EACvE,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,kFAAkF;AACpF;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,+EAA+E;EAC/E,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/**\n * AdminPainel - Estilo padrão dos outros painéis (Painel de Score)\n * Tema moderno e tecnológico Sonik\n */\n\n/* ==================== Tema (escopo do painel) ==================== */\n.admin-painel-v2 {\n  --brand-900: #0a3ea2;\n  --brand-700: #1060ff;\n  --brand-500: #1e75ff;\n  --brand-300: #a8c7ff;\n  --brand-100: #dbeafe;\n  --card: #ffffff;\n  --bg: #f0f4f9;\n  --bg-gradient: linear-gradient(135deg, #f0f4f9 0%, #e8f0f7 100%);\n  --text: #1f2937;\n  --muted: #6b7280;\n  --ok: #16a34a;\n  --bad: #ef4444;\n  --ring: #60a5fa;\n  --shadow-sm: 0 2px 4px rgba(17, 12, 12, 0.04);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);\n  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.12);\n  --shadow-xl: 0 20px 50px rgba(0, 0, 0, 0.15);\n\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  background: var(--bg-gradient);\n  background-attachment: fixed;\n  color: var(--text);\n  position: relative;\n}\n\n.admin-painel-v2 * {\n  box-sizing: border-box;\n}\n\n/* Efeito de partículas no fundo */\n.admin-painel-v2::before {\n  content: \"\";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image:\n    radial-gradient(circle at 20% 50%, rgba(30, 117, 255, 0.03) 0%, transparent 50%),\n    radial-gradient(circle at 80% 80%, rgba(16, 96, 255, 0.03) 0%, transparent 50%),\n    radial-gradient(circle at 40% 20%, rgba(10, 62, 162, 0.02) 0%, transparent 50%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* ==================== Header (Hero) ==================== */\n.admin-painel-v2 .hero {\n  background: linear-gradient(135deg, #0a3ea2 0%, #1060ff 30%, #1e75ff 70%, #3b82f6 100%);\n  background-size: 200% 200%;\n  animation: adminGradientShift 8s ease infinite;\n  color: #fff;\n  padding: 32px 18px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(10, 62, 162, 0.2);\n}\n\n@keyframes adminGradientShift {\n  0%, 100% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n}\n\n.admin-painel-v2 .hero::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.08) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.admin-painel-v2 .hero__inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  position: relative;\n  z-index: 1;\n}\n\n.admin-painel-v2 .brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  color: inherit;\n  margin-right: auto;\n  transition: transform 0.3s ease;\n}\n\n.admin-painel-v2 .brand:hover {\n  transform: translateX(2px);\n}\n\n.admin-painel-v2 .hero .title {\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  font-size: 28px;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  background: linear-gradient(180deg, #ffffff 0%, #e0e7ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.admin-painel-v2 .toolbar {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n/* ==================== Botões ==================== */\n.admin-painel-v2 .btn {\n  background: linear-gradient(135deg, #1060ff 0%, #1e75ff 100%);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 12px 20px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  box-shadow: 0 8px 20px rgba(16, 96, 255, 0.3);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  text-decoration: none;\n}\n\n.admin-painel-v2 .btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 28px rgba(16, 96, 255, 0.4);\n  background: linear-gradient(135deg, #1e75ff 0%, #3b82f6 100%);\n}\n\n.admin-painel-v2 .btn:active {\n  transform: translateY(0);\n}\n\n.admin-painel-v2 .btn--ghost {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.admin-painel-v2 .btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n.admin-painel-v2 .btn--secondary {\n  background: #f1f5f9;\n  color: #475569;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.admin-painel-v2 .btn--secondary:hover {\n  background: #e2e8f0;\n  color: #334155;\n  transform: translateY(-1px);\n}\n\n/* ==================== Layout ==================== */\n.admin-painel-v2 .wrap {\n  max-width: 1200px;\n  margin: 24px auto;\n  padding: 0 16px;\n  position: relative;\n  z-index: 1;\n}\n\n/* ==================== Card ==================== */\n.admin-painel-v2 .card {\n  background: var(--card);\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: var(--shadow-md);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  position: relative;\n  overflow: hidden;\n}\n\n.admin-painel-v2 .card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--brand-500), var(--brand-700));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.admin-painel-v2 .card:hover::before {\n  opacity: 1;\n}\n\n.admin-painel-v2 .card:hover {\n  box-shadow: var(--shadow-xl);\n  transform: translateY(-4px);\n  border-color: rgba(30, 117, 255, 0.2);\n}\n\n.admin-painel-v2 .card h3 {\n  margin: 0 0 16px 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-painel-v2 .card h3::before {\n  content: \"\";\n  width: 4px;\n  height: 20px;\n  background: linear-gradient(180deg, var(--brand-500), var(--brand-700));\n  border-radius: 2px;\n}\n\n/* ==================== Busca ==================== */\n.admin-painel-v2 .search-row {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr auto;\n  align-items: start;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 520px) {\n  .admin-painel-v2 .search-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-painel-v2 .search-row input[type=\"text\"] {\n  padding: 14px 18px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  font-size: 16px;\n  outline: none;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.admin-painel-v2 .search-row input[type=\"text\"]:hover {\n  border-color: var(--brand-300);\n  box-shadow: 0 4px 8px rgba(30, 117, 255, 0.1);\n}\n\n.admin-painel-v2 .search-row input[type=\"text\"]:focus {\n  border-color: var(--brand-500);\n  box-shadow: 0 0 0 4px rgba(30, 117, 255, 0.15), 0 4px 12px rgba(30, 117, 255, 0.2);\n}\n\n/* ==================== Tabela (restr-table) ==================== */\n.admin-painel-v2 .restr-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  table-layout: auto;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.admin-painel-v2 .restr-table thead th {\n  text-align: left;\n  font-weight: 700;\n  font-size: 11px;\n  color: #475569;\n  padding: 14px 16px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.admin-painel-v2 .restr-table tbody td {\n  padding: 14px 16px;\n  font-size: 14px;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n  word-wrap: break-word;\n  max-width: 200px;\n  transition: background 0.2s ease;\n}\n\n.admin-painel-v2 .restr-table tbody tr:hover td {\n  background: #f8fafc;\n}\n\n.admin-painel-v2 .restr-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Chips de permissão */\n.admin-painel-v2 .chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #eef2f7 0%, #e5e7eb 100%);\n  color: #1f2937;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.admin-painel-v2 .chip--brand {\n  background: linear-gradient(135deg, var(--brand-100) 0%, var(--brand-300) 100%);\n  color: var(--brand-900);\n}\n\n/* Muted text */\n.admin-painel-v2 .muted {\n  color: var(--muted);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Section head */\n.admin-painel-v2 .section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 8px 0 12px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #f0f4f9;\n}\n\n.admin-painel-v2 .section-head h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text);\n}\n\n/* Overrides para MUI dentro do painel */\n.admin-painel-v2 .MuiOutlinedInput-root {\n  border-radius: 12px;\n}\n\n.admin-painel-v2 .MuiOutlinedInput-notchedOutline {\n  border-color: #e5e7eb;\n}\n\n.admin-painel-v2 .Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: var(--brand-500) !important;\n  border-width: 2px !important;\n}\n\n.admin-painel-v2 .MuiSelect-select,\n.admin-painel-v2 .MuiTableCell-root {\n  font-size: 14px;\n}\n\n.admin-painel-v2 .admin-table-wrap {\n  overflow-x: auto;\n  width: 100%;\n  margin-top: 16px;\n}\n\n.admin-painel-v2 .admin-table-wrap .restr-table {\n  min-width: 800px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
